module.exports = __webpack_public_path__ + "img/banner_top.9ff8a825.png";